var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotdarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "-20 0 100 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499791,
    d: "M13.214 3.05176e-05L26.6182 16.6922L40.0012 3.05176e-05H13.214Z",
    fill: "#29CB97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2134 3.05176e-05L0.000610352 16.6922L26.7878 50L40.0006 33.3845L13.2134 3.05176e-05Z",
    fill: "#29CB97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499791,
    d: "M13.4042 33.2925L26.7872 50.0001H0L13.4042 33.2925Z",
    fill: "#29CB97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotdarkTheme);
export default __webpack_public_path__ + "static/media/bot.darkTheme.67cee9e072a247b603b278201ad828ea.svg";
export { ForwardRef as ReactComponent };